<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>William Hardy lives in Spartanburg, SC, with his wife, Nancy. Not only being the published author of <em>Hell’s Island</em>, he also is a founding member and guitarist with the J Teal Band, and wrote three songs on their album, <em>Cooks,</em> which was officially released on Rockadrome Records and distributed and sold worldwide. He is presently working on his next book, <em>Gullah Gravestones II</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6a8508f0